import { render, staticRenderFns } from "./GInlineLanguageSelect.vue?vue&type=template&id=0e97d2f8&"
import script from "./GInlineLanguageSelect.vue?vue&type=script&lang=js&"
export * from "./GInlineLanguageSelect.vue?vue&type=script&lang=js&"
import style0 from "./GInlineLanguageSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VLabel,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e97d2f8')) {
      api.createRecord('0e97d2f8', component.options)
    } else {
      api.reload('0e97d2f8', component.options)
    }
    module.hot.accept("./GInlineLanguageSelect.vue?vue&type=template&id=0e97d2f8&", function () {
      api.rerender('0e97d2f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/GInlineLanguageSelect.vue"
export default component.exports